export enum DimensionUnitEnum {
	FOOT = 'FT',
	INCH = 'IN',
	METER = 'M',
	CENTIMETER = 'CM'
}
